import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { ArchiveConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useSnapshotArchivingDefaults = () => useQuery({
  queryKey: ["snapshotArchivingDefaults"],
  queryFn: () => defaultOnError(
    ArchiveConfig.snapshotArchivingDefaults(),
    i18n.t("notifications.fetch_snapshot_archiving_defaults_failed", { ns: "enterprise_archive" }),
    i18n.t("notifications.fetch_snapshot_archiving_defaults_failed_title", { ns: "enterprise_archive" })
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingDefaults;
